module.exports = __webpack_public_path__ + "img/Ramiro.b3c47fb1.jpeg";